export default __webpack_public_path__ + "static/media/40.e79db579.png";